import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskDirective } from 'ngx-mask';
import { ClientService } from '../../../core/api/client.service';
import { DateInputComponent } from '../../../shared/components/date-input/date-input.component';
import { toApiDate } from '../../../shared/utils/date.utils';

@Component({
  selector: 'app-client-create',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatFormFieldModule, MatInputModule, MatSnackBarModule, MatProgressSpinnerModule,
    NgxMaskDirective,
    DateInputComponent,
  ],
  templateUrl: './client-create.component.html',
  styleUrl: './client-create.component.scss',
})
export class ClientCreateComponent {
  form: FormGroup;
  submitting = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private clientService: ClientService,
    private snackBar: MatSnackBar,
  ) {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      email: [''],
      driverLicense: [''],
      driverLicenseDate: [null],
      passportNumber: [''],
      passportIssuedDate: [null],
      passportIssuedBy: [''],
      birthDate: [null],
      notes: [''],
    });
  }

onSubmit(): void {
    if (this.form.invalid || this.submitting) return;
    this.submitting = true;
    const v = this.form.value;
    const data = {
      first_name: v.firstName,
      middle_name: v.middleName || '',
      last_name: v.lastName,
      phone: v.phone,
      email: v.email || '',
      driver_license: v.driverLicense || '',
      driver_license_date: v.driverLicenseDate ? toApiDate(new Date(v.driverLicenseDate)) : null,
      passport_number: v.passportNumber || '',
      passport_issued_date: v.passportIssuedDate ? toApiDate(new Date(v.passportIssuedDate)) : null,
      passport_issued_by: v.passportIssuedBy || '',
      birth_date: v.birthDate ? toApiDate(new Date(v.birthDate)) : null,
      notes: v.notes || '',
    };
    this.clientService.create(data).subscribe({
      next: () => {
        this.snackBar.open('Клиент создан', 'ОК', { duration: 3000 });
        this.router.navigate(['/clients']);
      },
      error: (err: any) => {
        this.submitting = false;
        const errorData = err.error;
        if (errorData && typeof errorData === 'object' && !Array.isArray(errorData)) {
          this.setServerErrors(errorData);
          const nonField = errorData.all || errorData.non_field_errors;
          if (nonField) {
            const msg = Array.isArray(nonField) ? nonField[0] : String(nonField);
            this.snackBar.open(msg, 'ОК', { duration: 5000 });
          }
        } else {
          const msg = Array.isArray(errorData) ? errorData[0] : 'Ошибка создания';
          this.snackBar.open(msg, 'ОК', { duration: 5000 });
        }
      },
    });
  }

  private readonly apiFieldToControl: Record<string, string> = {
    first_name: 'firstName',
    middle_name: 'middleName',
    last_name: 'lastName',
    phone: 'phone',
    email: 'email',
    driver_license: 'driverLicense',
    driver_license_date: 'driverLicenseDate',
    passport_number: 'passportNumber',
    passport_issued_date: 'passportIssuedDate',
    passport_issued_by: 'passportIssuedBy',
    birth_date: 'birthDate',
    notes: 'notes',
  };

  private setServerErrors(errors: Record<string, any>): void {
    for (const [apiField, controlName] of Object.entries(this.apiFieldToControl)) {
      const control = this.form.get(controlName);
      if (control && errors.hasOwnProperty(apiField)) {
        const messages = errors[apiField];
        const msg = Array.isArray(messages) ? messages[0] : String(messages);
        control.setErrors({ ...control.errors, serverError: msg });
      }
    }
  }
}
